import React from "react";
import { Layout, theme } from "antd";
import AppSidebar from "./AppSidebar";
import AppHeader from "./AppHeader";
import AppFooter from "./AppFooter";
import { Navigate, Route, Routes } from "react-router-dom";
import { layout_routes } from "../routes/layout_routes";

const { Content } = Layout;

const App = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Layout style={{ height: "100vh" }}>
      <AppSidebar />
      <Layout>
        <AppHeader />

        <Content
          style={{
            margin: "24px 16px 0",
          }}
        >
          <div
            style={{
              padding: 12,
              height: "100%",
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              overflowY: "auto",
            }}
          >
            <Routes>
              <Route path="/" element={<Navigate to="/properties" replace />} />
              {layout_routes.map((route) => (
                <Route
                  key={route.key}
                  path={route.path}
                  element={route.element}
                />
              ))}
            </Routes>
          </div>
        </Content>

        <AppFooter />
      </Layout>
    </Layout>
  );
};
export default App;
